(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["az-mobile-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('az-mobile-navigation')) {
    customElements.define('az-mobile-navigation', class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-az-menu-toggle]');
          if (toggle && this.contains(toggle)) {
            const children = this.querySelector('#' + toggle.getAttribute('aria-controls'));
            if (!children) return;
            const expanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', String(!expanded));
            children.hidden = expanded;
            return;
          }
          const tab = event.target.closest('[data-az-menu-tab]');
          if (!tab || !this.contains(tab)) return;
          const selected = tab.dataset.azMenuTab;
          this.querySelectorAll('[data-az-menu-tab]').forEach((button) => {
            button.setAttribute('aria-expanded', String(button === tab));
          });
          this.querySelectorAll('[data-az-menu-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.azMenuPanel !== selected;
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
